import { cn } from "@/lib/utils";

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex h-8 items-center rounded-md bg-foreground px-2", className)}>
      <img src="/logo.avif" alt="Spares" className="h-5 w-auto" />
    </div>
  );
}
